import {
    LEAD_APPROVAL_GET_LEADS,
    LEAD_APPROVAL_GET_LEADS_SUCCESS,
    LEAD_APPROVAL_GET_LEADS_FAILURE,
} from '../constants/lead_approval_get_leads.constants';

export const leadApprovalGetLeadsRequest = params => ({
    type: LEAD_APPROVAL_GET_LEADS,
    params,
});


export const leadApprovalGetLeadsSuccess = leads => ({
    type: LEAD_APPROVAL_GET_LEADS_SUCCESS,
    leads,
});

export const leadApprovalGetLeadsFailure = error => ({
    type: LEAD_APPROVAL_GET_LEADS_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/redux/actions/lead_approval_get_leads.actions.js